import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { theme } from '@garnish/constants';

import { useResponsive } from '../../../../hooks';

/**
 * Returns Modal bottom spacing with respect of safe area bottom inset.
 */
export const useModalBottomSpacing = () => {
  const { currentBreakpoint } = useResponsive();

  const { bottom: safeAreaBottomInset } = useSafeAreaInsets();

  // Since modal is rendered in the center for larger breakpoints,
  // we only use dynamic bottom spacing for the `XS` breakpoint.
  const shouldUseDynamicBottomSpacing =
    safeAreaBottomInset > 0 && currentBreakpoint.isMobile;

  if (shouldUseDynamicBottomSpacing) {
    const isSafeAreaLargerThanStandardSpacing =
      safeAreaBottomInset > MODAL_DIALOG_STANDARD_SPACING;

    return isSafeAreaLargerThanStandardSpacing
      ? 0
      : MODAL_DIALOG_STANDARD_SPACING - safeAreaBottomInset;
  }

  return MODAL_DIALOG_STANDARD_SPACING;
};

// ─── Constants ───────────────────────────────────────────────────────────────

const MODAL_DIALOG_STANDARD_SPACING = theme.spacing.large;
